// extracted by mini-css-extract-plugin
export default {"divider":"RTpg0"};